import React, { Suspense } from "react";
//import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Container from "@material-ui/core/Container";
import CustomThemeProvider from "./theme/CustomThemeProvider";
import "./i18n";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import Login from "../features/authentication/Login";
import { Hidden } from "@material-ui/core";

import PrivateRoute from "./components/private/PrivateRoute";
import MainLoader from "./components/MainLoader";

import Home from "../features/home/Home";
import HomeOld from "../features/homeOld/Home";

//import { selectUser } from "../features/authentication/authenticationSlice";

import Nav from "./components/public/Nav";
import NavMobile from "./components/public/NavMobile";
import NavOld from "./components/NavOld";
import Dashboard from "../features/dashboard/Dashboard";
import Alerts from "../features/alerts/Alerts";
import Test from "../features/test/Test";
import Structure from "../features/structure/Structure";
import SchedulesList from "../features/schedules/SchedulesList/SchedulesList";
import LogsList from "../features/logs/LogsList/LogsList";

function App() {
  //const user = useSelector(selectUser);
  //const dispatch = useDispatch();

  return (
    <CustomThemeProvider>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Container maxWidth={false} disableGutters={true}>
        <Suspense fallback={<MainLoader />}>
          <Router>
            <Switch>
              <Route path="/">
                <Hidden smUp>
                  <NavMobile />
                </Hidden>
                <Hidden xsDown>
                  <Nav />
                </Hidden>
                <Home />
              </Route>
            </Switch>
          </Router>
        </Suspense>
      </Container>
      </MuiPickersUtilsProvider>
    </CustomThemeProvider>
  );
}

export default App;
